/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q1_BInputs */

const en_consult_q1_b = /** @type {(inputs: Consult_Q1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product or problem already validated`)
};

const id_consult_q1_b = /** @type {(inputs: Consult_Q1_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk atau masalah sudah tervalidasi`)
};

/**
* | output |
* | --- |
* | "Product or problem already validated" |
*
* @param {Consult_Q1_BInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q1_b = /** @type {((inputs?: Consult_Q1_BInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q1_BInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q1_b(inputs)
	return en_consult_q1_b(inputs)
});